import React from 'react';
import { useLocation } from 'react-router-dom';
import { useVerifyMutation } from '../../services/api';
import { useAuth } from '../../hooks/auth';
import { useConfig } from '../../hooks/config';
import Layout from '../../shared/Layout';

const Verify = () => {

	const location = useLocation();
	const { refetchUser, user } = useAuth();
	const { config } = useConfig();
	const urlParams = new URLSearchParams(location.search);
	const [verify, { data, isSuccess, isLoading, isError }] = useVerifyMutation();

	React.useEffect(() => {
		if(config) {
			verify({
				user_id: urlParams.get('user_id'),
				validation_code: urlParams.get('validation_code')
			});
		}
	}, [config]);

	React.useEffect(() => {
		if(isSuccess || isError) {
			window.location.href="/"
		}
	}, [isSuccess, isError]);

	return(
		<Layout 
			seo={{}}
			loading={isLoading}
		/>
	);
}

export default Verify;